/// <reference path="../../Div.ts" />
namespace HA.Core.HTML.Form {
    export class FormItem extends Div {
        public getName() {
            return this.getAttribute("id");
        }

        /**
         *
         * @returns {Tag}
         */
        public reset() {
            return this.getITag().clear();
        }

        public getValue(): string | boolean {
            return this.getITag().getText();
        }

        /**
         *
         * @returns {string}
         */
        public getType() {
            return "FormType";
        }

        public getTitle(): string {
            return this.getAttr("t");
        }

        /**
         *
         * @returns {string}
         */
        public getAttr(name: string) {
            const tag = this.findByAttribute("info");
            return tag ? tag.getAttribute(name) : null;
        }

        public getITag(): Input {
            return this.get("itag");
        }

        protected createItemTag(formItem: any): Tag {

            const label = this.trans("label");

            const formElementTitle = label ? {
                c: [
                    {
                        class: "formititle",
                        t: "div",
                        txt: label,
                    },
                    {
                        attributes: [
                            {n: "counter", v: 1},
                        ],
                        class: "counter",
                        t: "div",
                    },
                ],
                class: "formihead",
                t: "fc",
            } : null;
            return new Tag({
                attributes: [
                    {n: "formi", v: 1},
                    {n: "id", v: this.getId() || "fi" + this.get("name")},
                ],
                c: [
                    {t: "div", class: "state"},
                    {
                        c: [
                            {
                                attributes: [
                                    {n: "name", v: this.get("name")},
                                    {n: "n", v: this.get("name")},
                                    {n: "max", v: this.get("max")},
                                    {n: "t", v: this.trans("label")},
                                    {n: "info", v: 1},
                                    {n: "choices", v: this.translate(this.get("choices"))},
                                ],
                                c: [
                                    {
                                        c: [
                                            formElementTitle,
                                            {
                                                c: [formItem],
                                                class: "tbxc",
                                                t: "div",
                                            }],
                                        t: "cfc",
                                    }],
                                class: "textline",
                                t: "div",
                            }],
                        class: "ibox",
                        t: "div",
                    },
                ],
                class: "formi",
                t: "div",
            });
        }
    }
}
